import Script from "next/script";

// Klaviyo onsite tracking (klaviyo.js) — MARKETING analytics only.
// Loads the public-key onsite snippet so client events (Viewed Product / Added
// to Cart) and post-auth identity stitching (§4.4) can fire. Renders nothing
// when NEXT_PUBLIC_KLAVIYO_PUBLIC_KEY is absent, so the app runs safely with no
// key configured (mirrors the "disabled" default on the server).
export const KlaviyoScript = () => {
  const publicKey = process.env.NEXT_PUBLIC_KLAVIYO_PUBLIC_KEY;
  if (!publicKey) return null;

  return (
    <Script
      id="klaviyo-onsite"
      strategy="afterInteractive"
      src={`https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${publicKey}`}
    />
  );
};

export default KlaviyoScript;
